var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.5,106c-249.91,0-452.5,202.59-452.5,452.5s202.59,452.5,452.5,452.5,452.5-202.59,452.5-452.5S771.41,106,521.5,106ZM761.82,430.34l-261.98,261.98c-14.05,14.05-35.37,16.41-51.86,7.08-5.59-2.32-10.77-5.86-15.14-10.6l-115.85-125.47c-16.2-17.56-15.11-44.92,2.44-61.12l3.49-3.22c17.56-16.21,44.92-15.11,61.12,2.44l88.51,95.86,228.11-228.11c16.89-16.89,44.27-16.89,61.16,0,8.45,8.44,12.67,19.51,12.67,30.58s-4.22,22.14-12.67,30.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck01);
export default __webpack_public_path__ + "static/media/check_01.7e2926537d0dbd0883476643c0b64c14.svg";
export { ForwardRef as ReactComponent };